import { useReactiveVar } from "@apollo/client";
import Icon from 'components/Icon';
import React from 'react';
import { Button } from "components/Buttons";
import Modal from "../../../../components/Modal";
import {
  getAddMedia,
  setAddMedia,
  SHOW_MEDIA_NAME_MODAL, SHOW_THUMBNAIL_SELECT_MODAL,
  SHOW_UPLOAD_FROM_FILE_MODAL
} from "../../../../graphql/LocalState/addMedia";
import { errorAlert } from "../../../../utils/alert";
import { AcceptedMedia } from "../../utils";
import DropMediaZone from "../DropMediaZone";
import { MEDIA_RATIOS, getMediaRatio } from "utils/mediaUtils";
import { toast } from "react-toastify";

function UploadFromFileModal({onClose, onBack, onNext}) {
  const { activeModal, droppedFiles, projectRatio } = useReactiveVar(getAddMedia);
  
  const handleNext = (isImage, src) => {
    setAddMedia({
      newMediaObject: {
        is_image: isImage,
        temp_storage_url: src,
        url: src
      },
    });
    const nextModal = (isImage) ? SHOW_MEDIA_NAME_MODAL : SHOW_THUMBNAIL_SELECT_MODAL;
    onNext(nextModal, SHOW_UPLOAD_FROM_FILE_MODAL)
  }

  const checkMediaRatio = (mediaRatio, isImage, src) => {
    if(projectRatio != mediaRatio) {
      toast.error("Media ratio doesn't match project ratio.", {
        position: 'top-right',
        theme:"colored"
      });
    } else {
      handleNext(isImage, src);
    }
  }

  return (
    <Modal
      onBack={onBack}
      onClose={onClose}
      height={550}
      width={600}
      closeMaskOnClick={false}
	  enableFooter={true}
      show={activeModal===SHOW_UPLOAD_FROM_FILE_MODAL}
      heading={
        <><Icon name="cloud-upload"/>Upload File</>
      }
	  submitButton={
		<Button  primary onClick={onClose}>Done</Button>
	  }
    >
      <div style={{ padding: 10 }}>
        {/* We add this here to ensure the dropzone delete's when this modal isn't active. This is so any errors are cleared when the user clicks back */}
        {(activeModal===SHOW_UPLOAD_FROM_FILE_MODAL &&  <DropMediaZone
          initialFiles={droppedFiles}
          onError={()=>errorAlert({text: 'Unable to upload media'})}
          onSuccess={({src}, file) => {
            const isImage = file && file.type !== 'video/mp4' ? 1 : 0;
            if(isImage) {
              const image = document.createElement('img');
              image.src = src;
              image.addEventListener('load', () => {
                const imageRatio = getMediaRatio(image.width, image.height);
                checkMediaRatio(imageRatio, isImage, src);
              });
            } else {
              const video = document.createElement('video');
              video.src = src;
              video.addEventListener('loadedmetadata', () => {
                const videoRatio = getMediaRatio(video.videoWidth, video.videoHeight);
                checkMediaRatio(videoRatio, isImage, src);
              });
            }
          }}
          tempUpload={true}
          // uploadSuccessEndpoint={'file/upload'}
          params={{}}
          accept={AcceptedMedia}
        />)}
        <p style={{ textAlign: 'center'}}>
          All uploaded medias should be aspect ratio { projectRatio }
        </p>
      </div>
    </Modal>
  )
}


export default UploadFromFileModal;